import { ref as g, toRefs as z, resolveComponent as m, openBlock as D, createElementBlock as _, normalizeClass as k, createVNode as v, createSlots as S, withCtx as f, renderSlot as p, createTextVNode as y } from "vue";
import N from "./design-system.es83.js";
import w from "./design-system.es306.js";
import { useResizeObserver as x } from "./design-system.es125.js";
import R from "./design-system.es118.js";
/* empty css                    */
import q from "./design-system.es128.js";
const B = {
  name: "DsPaginationFooter",
  components: {
    DsPager: N,
    DsPaginationShowing: w
  },
  props: {
    /**
     * The total number of items.
     */
    total: {
      type: Number,
      required: !0
    },
    /**
     * The number of items per page.
     */
    pageSize: {
      type: Number,
      required: !0
    },
    /**
     * The current page. This cannot be used in conjunction with the `offset` prop.
     */
    page: {
      type: Number,
      default: null
    },
    /**
     * The current offset. This cannot be used in conjunction with the `page` prop.
     */
    offset: {
      type: Number,
      default: null
    }
  },
  emits: ["change"],
  setup(n, { emit: a }) {
    const r = g(null), e = g("large"), i = g(!1), {
      page: c,
      offset: l,
      total: u,
      pageSize: t
    } = z(n), {
      currentPage: d,
      pageCount: h,
      start: P,
      end: C
    } = R({
      page: c,
      offset: l,
      total: u,
      pageSize: t
    });
    function b(s) {
      const o = (s - 1) * t.value;
      a("change", { page: s, offset: o });
    }
    return x(r, (s) => {
      const { width: o } = s[0].contentRect;
      o >= 768 ? e.value = "large" : o >= 686 ? e.value = "medium" : o >= 604 ? e.value = "small" : e.value = "extra-small", i.value = o < 522;
    }), {
      el: r,
      size: e,
      stacked: i,
      currentPage: d,
      pageCount: h,
      start: P,
      end: C,
      handlePageChange: b
    };
  }
};
function F(n, a, r, e, i, c) {
  const l = m("DsPager"), u = m("DsPaginationShowing");
  return D(), _("div", {
    ref: "el",
    class: k(["ds-pagination-footer", { "ds-pagination-footer--stacked": e.stacked }])
  }, [
    v(l, {
      "page-count": e.pageCount,
      "current-page": e.currentPage,
      size: e.size,
      onChange: e.handlePageChange
    }, S({
      page: f(({ page: t, current: d }) => [
        p(n.$slots, "page", {
          page: t,
          current: d
        }, void 0, !0)
      ]),
      _: 2
    }, [
      n.$slots.previous ? {
        name: "previous",
        fn: f(({ disabled: t }) => [
          p(n.$slots, "previous", { disabled: t }, void 0, !0)
        ]),
        key: "0"
      } : void 0,
      n.$slots.next ? {
        name: "next",
        fn: f(({ disabled: t }) => [
          p(n.$slots, "next", { disabled: t }, void 0, !0)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["page-count", "current-page", "size", "onChange"]),
    a[2] || (a[2] = y()),
    v(u, {
      start: e.start,
      end: e.end,
      total: r.total
    }, null, 8, ["start", "end", "total"])
  ], 2);
}
const A = /* @__PURE__ */ q(B, [["render", F], ["__scopeId", "data-v-e7b7ead6"]]);
export {
  A as default
};
//# sourceMappingURL=design-system.es85.js.map
